export const PUBLISHED_STRUCTURED_CONTENT_FIELDS = `
    structuredContent {
        schemaVersion
        type
        title
        summary
        metadata {
            key
            label
            value
        }
        sections {
            id
            kind
            title
            checkable
            entries {
                id
                label
                text
                detail
                quantity
                unit
                optional
                duration
                mediaRef
                order
                emoji
            }
        }
    }
`;
